<div class="label">
  {{ label }}
</div>

@if (!control?.value?.id && !imageUploadProgress) { @if (!processingImage) {
<button
  class="upload-button"
  color="primary"
  mat-button
  tabIndex="-1"
  type="button"
>
  <span class="btn-wrapper" (click)="handleFileUploadAttempt()">
    <mat-icon>add_photo_alternate</mat-icon>
    <span class="btn-text">{{ 'common.label.uploadImage' | translate }}</span>
  </span>
</button>
} @if (processingImage) {
<span class="imageProcessing">{{
  'common.label.processImage' | translate
}}</span>
}
<input
  (change)="uploadImage()"
  #fileInput
  accept="image/png, image/jpeg, image/gif"
  hidden
  type="file"
/>
} @else {
<div class="flex-row flex-align-items-center image-preview">
  <div class="image-name flex-grow">
    @if (imageUploadProgress?.name) {
    {{ imageUploadProgress.name }}
    } @else { @if (imageUrl) {
    <img src="{{ 'mediaUrl' | env }}/{{ imageUrl }}" class="image" />
    } }
  </div>
  @if (!imageUploadProgress) {
  <button
    (click)="removeImage()"
    [matTooltip]="'Löschen'"
    mat-icon-button
    tabindex="-1"
    type="button"
  >
    <mat-icon class="material-icons">delete_outline</mat-icon>
  </button>
  } @if (!imageUploadProgress) {
  <button (click)="showImage()" mat-icon-button tabindex="-1" type="button">
    <mat-icon class="material-icons">zoom_out_map</mat-icon>
  </button>
  }
</div>
} @if (imageUploadProgress) {
<mat-progress-bar [value]="imageUploadProgress.percentage"></mat-progress-bar>
<div class="progress-label label">{{ imageUploadProgress.percentage }}%</div>
}
